export default "__VITE_ASSET__bajTwpsL__"